(function () {
  const cookieName = 'LBBWAMDisclaimerInstAccepted';

  // Hilfsfunktion zum Auslesen eines Cookies (Ersatz für $.cookie(name))
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  // Hilfsfunktion zum Setzen eines Cookies (Ersatz für $.cookie(name, value, options))
  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax`;
  };

  const disclaimerAccepted = getCookie(cookieName);
  const disclaimerLayer = document.getElementById('disclaimerlayer');
  const acceptBtn = document.getElementById('accept_disclaimer_general');
  const body = document.body;

  // Event Listener für den Accept-Button
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      if (disclaimerLayer) {
        disclaimerLayer.remove();
      }
      body.classList.remove('has-layer');
      setCookie(cookieName, 'true', 30);
    });
  }

  // Logik beim Laden der Seite
  if (!disclaimerAccepted && disclaimerLayer) {
    disclaimerLayer.style.display = 'block'; // Entspricht .show()
    body.classList.add('has-layer');
  } else {
    if (disclaimerLayer) {
      disclaimerLayer.remove();
    }
    body.classList.remove('has-layer');
  }

  // Zusätzlicher Check (wie im Original)
  if (!disclaimerLayer) {
    body.classList.remove('has-layer');
  }
})();